import React, { Component } from 'react'
import { DragSource } from 'react-dnd';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { Icon, IconButton } from '@material-ui/core';

/* drag sources */
const itemSource = {
    beginDrag(props) {
        // console.log(props)
        return props.item;
    },
    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        let target = monitor.getDropResult()
        props.onDrop(props.item, target.week, target.day, props.module_id, target.dayValue)
        return true
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}


class DraggableSelectedEvent extends Component {

    render() {
        let { connectDragSource, isDragging } = this.props;

        return (
            connectDragSource(
                <div style={{ opacity: isDragging ? 0.5 : 1 }}>
                    <SnackbarContent style={{ backgroundColor: '#DDDDDD', maxWidth: '100%', minWidth: '90%', color: 'black' }} message={this.props.item.LessonName}
                        action={
                            <IconButton
                                onClick={(ev) => {
                                    this.props.onDelete(this.props.item.lesson_id);
                                }}
                            >
                                <Icon>delete</Icon>
                            </IconButton>}
                    />
                </div>)


        );
    }
}

// DraggableSidebarEvent.propTypes = propTypes;


export default DragSource('item', itemSource, collectSource)(DraggableSelectedEvent);


// WEBPACK FOOTER //
// src/main/content/module/scheduleComponents/DraggableSelectedLesson.js